/* AgriEID redesign: click to zoom for the buy box gallery (sections/ae-buy-box.liquid).
   One click on the main product photo opens it full screen. A click on the full-screen photo magnifies it:
   the picture then follows the mouse, or is dragged with a finger on a touch screen. The arrows step through
   the same pictures as the gallery on the page, and the page stays on the picture last looked at.
   No dependencies. Own file, styles included, so it can change without touching ae-redesign.js or .css. */
(function () {
  'use strict';

  var AE = window.AE = window.AE || {};
  var WIDTHS = [1200, 1600, 2000, 2400];   // sizes asked from the image CDN, which never enlarges past the original
  var view = null;                         // the open viewer
  var styled = false;
  var backing = false;                     // our own history.back() is on its way

  function $(sel, root) { return (root || document).querySelector(sel); }
  function clamp(n) { return Math.max(0, Math.min(1, n)); }
  function icon(d) {
    return '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + d + '</svg>';
  }
  var ICON = {
    zin: icon('<circle cx="10.5" cy="10.5" r="6.5"/><path d="M20 20l-4.6-4.6M10.5 8v5M8 10.5h5"/>'),
    zout: icon('<circle cx="10.5" cy="10.5" r="6.5"/><path d="M20 20l-4.6-4.6M8 10.5h5"/>'),
    close: icon('<path d="M6 6l12 12M18 6L6 18"/>'),
    prev: icon('<path d="M15 5l-7 7 7 7"/>'),
    next: icon('<path d="M9 5l7 7-7 7"/>')
  };

  var CSS = [
    '.ae .ae-zoomable{cursor:zoom-in}',
    '.ae .ae-gzoom{position:absolute;top:16px;right:16px;width:40px;height:40px;margin:0;padding:0;border-radius:50%;border:1px solid #E5E7EB;background:#fff;color:#000080;cursor:zoom-in;display:flex;align-items:center;justify-content:center;box-shadow:0 2px 8px rgba(20,33,58,.12)}',
    '.ae .ae-gzoom:hover{border-color:#0F5BFF;color:#0F5BFF}',
    '.ae .ae-gzoom:focus-visible{outline:2px solid #0F5BFF;outline-offset:2px}',
    '.ae-zoom{outline:0;position:fixed;top:0;right:0;bottom:0;left:0;z-index:2147483000;background:#F4F4F4;color:#000080;font-family:"DM Sans",system-ui,sans-serif;-webkit-tap-highlight-color:transparent;-webkit-text-size-adjust:100%;text-size-adjust:100%;opacity:0;transition:opacity .16s ease}',
    '.ae-zoom.is-open{opacity:1}',
    '.ae-zoom__stage{position:absolute;top:0;right:0;bottom:0;left:0;box-sizing:border-box;padding:72px 84px 76px;display:flex;overflow:hidden;overscroll-behavior:contain;cursor:default}',
    '.ae-zoom__img{display:block;margin:auto;width:100%;height:100%;max-width:none;object-fit:scale-down;cursor:zoom-in;-webkit-user-select:none;user-select:none;-webkit-user-drag:none}',
    '.ae-zoom.is-in .ae-zoom__stage{padding:0;overflow:auto;-webkit-overflow-scrolling:touch;scrollbar-width:none}',
    '.ae-zoom.is-in .ae-zoom__stage::-webkit-scrollbar{display:none}',
    '.ae-zoom.is-in .ae-zoom__img{flex:none;object-fit:fill;cursor:zoom-out}',
    '.ae-zoom__btn{-webkit-appearance:none;appearance:none;position:absolute;width:44px;height:44px;min-width:0;min-height:0;margin:0;padding:0;border-radius:50%;border:1px solid #E5E7EB;background:#fff;color:#000080;cursor:pointer;display:flex;align-items:center;justify-content:center;box-shadow:0 2px 10px rgba(20,33,58,.14)}',
    '.ae-zoom__btn:hover{border-color:#0F5BFF;color:#0F5BFF}',
    '.ae-zoom__btn:focus-visible{outline:2px solid #0F5BFF;outline-offset:2px}',
    '.ae-zoom__btn[hidden]{display:none}',
    '.ae-zoom__close{top:14px;right:16px}',
    '.ae-zoom__mag{top:14px;right:70px}',
    '.ae-zoom__prev{top:50%;left:16px;margin-top:-22px}',
    '.ae-zoom__next{top:50%;right:16px;margin-top:-22px}',
    '.ae-zoom__cap{position:absolute;left:50%;bottom:18px;transform:translateX(-50%);box-sizing:border-box;max-width:calc(100% - 136px);padding:9px 16px;border-radius:999px;background:rgba(255,255,255,.94);box-shadow:0 2px 10px rgba(20,33,58,.12);font-size:14px;font-weight:600;line-height:1.3;letter-spacing:0;text-align:center;pointer-events:none}',
    '.ae-zoom__cap:empty{display:none}',
    '@media (max-width:749px){.ae-zoom__stage{padding:68px 10px 72px}.ae-zoom__prev,.ae-zoom__next{top:auto;bottom:12px;margin-top:0}.ae-zoom__cap{bottom:16px;font-size:13px}}',
    '@media (prefers-reduced-motion:reduce){.ae-zoom{transition:none}}'
  ].join('');

  function addStyles() {
    if (styled) return;
    styled = true;
    var s = document.createElement('style');
    s.setAttribute('data-ae-zoom-css', '');
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  // the same picture at another width; an address without a width (not on the Shopify CDN) is left alone
  function sized(src, need) {
    if (!/[?&]width=\d+/.test(src)) return src;
    var w = WIDTHS[WIDTHS.length - 1];
    for (var i = 0; i < WIDTHS.length; i++) if (WIDTHS[i] >= need) { w = WIDTHS[i]; break; }
    return src.replace(/([?&]width=)\d+/, '$1' + w);
  }
  function widthOf(src) {
    var m = /[?&]width=(\d+)/.exec(src);
    return m ? Number(m[1]) : 0;
  }

  // where the picture itself sits on screen: it is centred in the image box and never drawn above its own size
  function picRect() {
    var img = view.img, r = img.getBoundingClientRect();
    if (view.zoomed) return r;
    var nw = img.naturalWidth || r.width, nh = img.naturalHeight || r.height;
    if (!nw || !nh) return r;
    var s = Math.min(r.width / nw, r.height / nh, 1), w = nw * s, h = nh * s;
    return { left: r.left + (r.width - w) / 2, top: r.top + (r.height - h) / 2, width: w, height: h };
  }

  // swap in a sharper file once it has loaded, when the picture is shown wider than the file on screen
  function sharpen(cssWidth) {
    var v = view;
    if (!v || !widthOf(v.src)) return;
    var want = sized(v.src, Math.ceil(cssWidth * (window.devicePixelRatio || 1)));
    if (widthOf(want) <= v.width) return;
    var token = v.token, pre = new Image();
    v.width = widthOf(want);
    pre.onload = function () { if (view === v && v.token === token) v.img.src = want; };
    pre.src = want;
  }

  function render() {
    var v = view, slide = v.box ? v.box.slides[v.box.slideIndex] : null;
    v.src = (slide && slide.src) || v.hero.currentSrc || v.hero.getAttribute('src') || '';
    v.width = widthOf(v.src);
    v.token++;
    v.img.alt = v.hero.getAttribute('alt') || '';
    v.img.src = v.src;                       // the file the page already has, so it shows at once
    var cap = $('[data-ae-caption]', v.root);
    v.cap.textContent = cap ? cap.textContent : '';
    var many = !!v.box && v.box.visibleSlides().length > 1;
    v.prev.hidden = v.next.hidden = !many;
  }

  function setMag(on) {
    var v = view;
    v.mag.innerHTML = on ? ICON.zout : ICON.zin;
    v.mag.setAttribute('aria-label', on ? 'Zoom out' : 'Zoom in');
    v.mag.setAttribute('aria-pressed', on ? 'true' : 'false');
  }

  // with a mouse the magnified picture follows the pointer: the edges are reached a little before the screen edge
  function pan(e) {
    var s = view.stage;
    s.scrollLeft = (s.scrollWidth - s.clientWidth) * clamp((e.clientX / s.clientWidth - 0.1) / 0.8);
    s.scrollTop = (s.scrollHeight - s.clientHeight) * clamp((e.clientY / s.clientHeight - 0.1) / 0.8);
  }

  function zoomIn(e) {
    var v = view;
    if (!v || v.zoomed) return;
    var p = picRect();
    if (!p.width || !p.height) return;
    var at = e && typeof e.clientX === 'number' && (e.clientX || e.clientY) ? e : null;   // a key press has no position
    var mouse = v.pointer === 'mouse';
    var k = mouse ? 2.5 : 3;
    var w = Math.round(p.width * k), h = Math.round(p.height * k);
    var fx = at ? clamp((at.clientX - p.left) / p.width) : 0.5, fy = at ? clamp((at.clientY - p.top) / p.height) : 0.5;
    v.zoomed = true;
    v.el.classList.add('is-in');
    v.img.style.width = w + 'px';
    v.img.style.height = h + 'px';
    if (at && mouse) pan(at);
    else {                                   // keep the point that was tapped under the finger
      v.stage.scrollLeft = fx * w - (at ? at.clientX : v.stage.clientWidth / 2);
      v.stage.scrollTop = fy * h - (at ? at.clientY : v.stage.clientHeight / 2);
    }
    setMag(true);
    sharpen(w);
  }

  function zoomOut() {
    var v = view;
    if (!v || !v.zoomed) return;
    v.zoomed = false;
    v.el.classList.remove('is-in');
    v.img.style.width = '';
    v.img.style.height = '';
    v.stage.scrollLeft = 0;
    v.stage.scrollTop = 0;
    setMag(false);
  }

  function step(dir) {
    var v = view;
    if (!v || !v.box) return;
    zoomOut();
    v.box.step(dir);                         // the page gallery moves too, so it is on the same picture after closing
    render();
  }

  function close(fromHistory) {
    var v = view;
    if (!v) return;
    view = null;
    document.removeEventListener('keydown', onKey, true);
    document.documentElement.style.overflow = v.overflow;
    v.el.classList.remove('is-open');
    setTimeout(function () { if (v.el.parentNode) v.el.parentNode.removeChild(v.el); }, 180);
    if (v.opener && v.opener.focus) { try { v.opener.focus({ preventScroll: true }); } catch (e) { v.opener.focus(); } }
    if (v.pushed && !fromHistory) { try { backing = true; window.history.back(); } catch (e) { backing = false; } }
  }

  function onKey(e) {
    var v = view;
    if (!v) return;
    // the key stops here: on the live store the chat assistant also listens for Esc and would open as the viewer closes
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); e.stopPropagation(); close(); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
    else if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
    else if (e.key === 'Tab') {              // keep the focus inside the viewer
      var list = [v.mag, v.closeBtn, v.prev, v.next].filter(function (b) { return !b.hidden; });
      var i = list.indexOf(document.activeElement);
      e.preventDefault();
      list[(i + (e.shiftKey ? -1 : 1) + list.length) % list.length].focus();
    }
  }

  function open(root, opener) {
    if (view) return;
    var hero = $('[data-ae-hero]', root);
    if (!hero) return;
    addStyles();
    var el = document.createElement('div');
    el.className = 'ae-zoom';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', 'Product photos');
    el.tabIndex = -1;
    el.innerHTML =
      '<div class="ae-zoom__stage"><img class="ae-zoom__img" alt="" draggable="false"></div>' +
      '<button type="button" class="ae-zoom__btn ae-zoom__mag"></button>' +
      '<button type="button" class="ae-zoom__btn ae-zoom__close" aria-label="Close">' + ICON.close + '</button>' +
      '<button type="button" class="ae-zoom__btn ae-zoom__prev" aria-label="Previous photo">' + ICON.prev + '</button>' +
      '<button type="button" class="ae-zoom__btn ae-zoom__next" aria-label="Next photo">' + ICON.next + '</button>' +
      '<span class="ae-zoom__cap" aria-live="polite"></span>';
    var v = view = {
      el: el, root: root, hero: hero, opener: opener || null,
      box: AE.buyBox && AE.buyBox.root === root && AE.buyBox.slides && AE.buyBox.slides.length ? AE.buyBox : null,
      stage: $('.ae-zoom__stage', el), img: $('.ae-zoom__img', el), cap: $('.ae-zoom__cap', el),
      mag: $('.ae-zoom__mag', el), closeBtn: $('.ae-zoom__close', el), prev: $('.ae-zoom__prev', el), next: $('.ae-zoom__next', el),
      zoomed: false, pointer: 'mouse', token: 0, src: '', width: 0, pushed: false,
      overflow: document.documentElement.style.overflow
    };
    setMag(false);

    v.img.addEventListener('load', function () {       // ask for a sharper file when the screen can show more
      if (view !== v || v.zoomed) return;
      var r = v.img.getBoundingClientRect(), nw = v.img.naturalWidth, nh = v.img.naturalHeight;
      if (nw && nh) sharpen(Math.min(r.width, r.height * nw / nh));
    });
    v.stage.addEventListener('pointerdown', function (e) { v.pointer = e.pointerType || 'mouse'; });
    v.stage.addEventListener('mousemove', function (e) { if (v.zoomed && v.pointer === 'mouse') pan(e); });
    v.stage.addEventListener('click', function (e) {
      el.focus({ preventScroll: true });       // a click on the picture must not drop the focus out of the viewer
      if (v.zoomed) { zoomOut(); return; }
      var p = picRect();
      var inside = e.clientX >= p.left && e.clientX <= p.left + p.width && e.clientY >= p.top && e.clientY <= p.top + p.height;
      if (inside) zoomIn(e); else close();     // a click beside the picture closes the viewer
    });
    // touch: swipe to the next picture while it is not magnified (magnified, a drag moves the picture)
    var x0 = null, y0 = 0;
    function pinched() { return !!(window.visualViewport && window.visualViewport.scale > 1.01); }
    v.stage.addEventListener('touchstart', function (e) {
      if (e.touches.length === 1) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; } else x0 = null;
    }, { passive: true });
    v.stage.addEventListener('touchmove', function (e) {   // the page behind must not scroll
      if (!v.zoomed && e.touches.length === 1 && e.cancelable && !pinched()) e.preventDefault();
    }, { passive: false });
    v.stage.addEventListener('touchend', function (e) {
      if (x0 === null || v.zoomed || pinched()) { x0 = null; return; }
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      x0 = null;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) step(dx < 0 ? 1 : -1);
    }, { passive: true });
    v.mag.addEventListener('click', function () { if (v.zoomed) zoomOut(); else zoomIn(null); });
    v.closeBtn.addEventListener('click', function () { close(); });
    v.prev.addEventListener('click', function () { step(-1); });
    v.next.addEventListener('click', function () { step(1); });

    document.body.appendChild(el);
    document.documentElement.style.overflow = 'hidden';
    document.addEventListener('keydown', onKey, true);
    render();
    void el.offsetWidth;                       // so the fade runs
    el.classList.add('is-open');
    try { v.closeBtn.focus({ preventScroll: true }); } catch (e) { v.closeBtn.focus(); }
    // the phone's back button closes the viewer instead of leaving the product page
    if (!(window.Shopify && window.Shopify.designMode)) {
      try { window.history.pushState({ aeZoom: true }, ''); v.pushed = true; } catch (e) { /* ignore */ }
    }
  }

  window.addEventListener('popstate', function () {
    if (backing) { backing = false; return; }   // the entry added on opening, taken back after a close button
    if (view) close(true);
  });

  function init(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('[data-ae-buy]'), function (buy) {
      var hero = $('[data-ae-hero]', buy), frame = hero ? hero.parentNode : null;
      if (!frame || frame.getAttribute('data-ae-zoom-ready')) return;
      frame.setAttribute('data-ae-zoom-ready', '1');
      addStyles();
      frame.classList.add('ae-zoomable');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ae-gzoom';
      btn.setAttribute('aria-label', 'Zoom photo');
      btn.setAttribute('aria-haspopup', 'dialog');
      btn.innerHTML = ICON.zin;
      frame.appendChild(btn);
      // a swipe on the photo changes the picture (ae-redesign.js) and must not also open the viewer
      var x0 = null, y0 = 0, swiped = 0;
      frame.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
      frame.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var t = e.changedTouches[0];
        if (Math.abs(t.clientX - x0) > 10 || Math.abs(t.clientY - y0) > 10) swiped = Date.now();
        x0 = null;
      }, { passive: true });
      frame.addEventListener('click', function (e) {
        var b = e.target.closest ? e.target.closest('button') : null;
        if (b && b !== btn) return;            // the previous and next arrows
        if (Date.now() - swiped < 500) return;
        e.preventDefault();
        open(buy, btn);
      });
    });
  }

  AE.zoom = { open: open, close: close };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
